module.exports = __webpack_public_path__ + "static/media/Winter 2019 (3).a3ee4b0c.jpg";